module.exports = __webpack_public_path__ + "assets/img/subsidy-hero.ab313737.webp";